module.exports = __webpack_public_path__ + "assets/img/991d003b2b05a5f3e19b5749a4552ea6.svg";